/**
 * Verification Failed First Time Component
 * Based on Figma: https://www.figma.com/design/8nBzg5I71TF3EWyr6NcpVa/Fiat?node-id=4838-63561
 *
 * Shown when identity verification fails for the first time,
 * allowing user to retry the verification process.
 */
import { CircleAlert } from 'lucide-react';

import { Button } from '@components/ui/button';

interface VerificationFailedFirstTimeProps {
  /**
   * Callback when "Maybe later" button is clicked
   */
  onMaybeLater: () => void;
  /**
   * Callback when "Resubmit" button is clicked
   */
  onResubmit: () => void;
}

export function VerificationFailedFirstTime({
  onMaybeLater,
  onResubmit,
}: Readonly<VerificationFailedFirstTimeProps>) {
  return (
    <div className="pt-5 sm:w-[394px]">
      {/* Content Section */}
      <div className="flex flex-col gap-3">
        {/* Warning Icon */}
        <CircleAlert className="size-6" />
        <h2 className="text-foreground">Verification unsuccessful</h2>
        <p className="text-muted-foreground text-body-paragraph1">
          There is an issue with the details you provided.
        </p>
      </div>

      {/* Action Buttons */}
      <div className="mt-6 flex gap-4">
        <Button
          type="button"
          variant="secondary"
          onClick={onMaybeLater}
          className="flex-1"
        >
          Maybe later
        </Button>
        <Button
          type="button"
          variant="primary"
          onClick={onResubmit}
          className="flex-1"
        >
          Resubmit
        </Button>
      </div>
    </div>
  );
}
